module.exports = __webpack_public_path__ + "img/t6.ecb663ae.png";